import { Input } from 'semantic-ui-react';
import { FormSection, ToggleField } from './FormSection';
import { Field, FieldGrid, ToggleList } from '../serviceFormStyles';

const NotificationsSection = ({ inputs, updateInputs, handleInputs }) => (
  <FormSection
    id="notificaciones"
    number={3}
    title="Notificaciones"
    description="Mensajes de confirmación que recibe el asistente al inscribirse."
  >
    <ToggleList>
      <ToggleField
        name="sendmail"
        label="Enviar correo de confirmación"
        checked={inputs.sendmail}
        onChange={() => updateInputs({ sendmail: !inputs.sendmail, templateId: '', listId: '' })}
      >
        <FieldGrid>
          <Field>
            <label htmlFor="templateId">Id de plantilla</label>
            <Input
              id="templateId"
              name="templateId"
              type="number"
              min={0}
              value={inputs.templateId ?? ''}
              onChange={handleInputs}
              fluid
            />
          </Field>
          <Field>
            <label htmlFor="listId">Id de lista</label>
            <Input
              id="listId"
              name="listId"
              type="number"
              min={0}
              value={inputs.listId ?? ''}
              onChange={handleInputs}
              fluid
            />
          </Field>
        </FieldGrid>
      </ToggleField>
      <ToggleField
        name="sendwhatsapp"
        label="Enviar WhatsApp de confirmación"
        checked={inputs.sendwhatsapp}
        onChange={() => updateInputs({ sendwhatsapp: !inputs.sendwhatsapp, whatsappTemplate: '' })}
      >
        <FieldGrid>
          <Field>
            <label htmlFor="whatsappTemplate">Nombre de la plantilla</label>
            <Input
              id="whatsappTemplate"
              name="whatsappTemplate"
              value={inputs.whatsappTemplate ?? ''}
              onChange={handleInputs}
              fluid
            />
            <p className="field__hint">
              La plantilla debe estar en idioma <strong>es_CO</strong>. Usa {'{{0}}'} para el
              nombre.
            </p>
          </Field>
        </FieldGrid>
      </ToggleField>
    </ToggleList>
  </FormSection>
);

export default NotificationsSection;
